<template>
    <div class="sub-page">
        <div class="btn-close"><Icon type="ios-close-circle-outline" @click="cancel" /></div>
        <div class="sub-page-bd">
            <Form ref="form" :model="formData" :label-width="120">
                <FormItem :label="$t('org_cname')" prop="role_cname">
                    <Input v-model="org_cname" disabled></Input>
                </FormItem>
                <FormItem :label="$t('role_cname')" prop="role_cname">
                    <Input :value="`[${cat_cname || `${$t('self')}`}] ${role_cname}`" disabled></Input>
                </FormItem>
                <FormItem :label="$t('select_func')">
                    <Tree class="tree-edit" ref="tree" :data="listData" show-checkbox multiple></Tree>
                </FormItem>
            </Form>
        </div>
        <div class="sub-page-ft">
            <Button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</Button>
            <Button type="primary" @click="submit('down-role-s2/set-func')">{{$t('save')}}</Button>
            <Button type="error" @click="submitAll" v-if="$base.getOrgId() != formData.org_id">{{$t('saverole')}}</Button>
        </div>
    </div>
</template>

<script>
    export default {
        data:function(){
            return{
                formData: {
                    role_id:'',
                    org_id:'',
                    funcs :[],
                },
                role_cname: '',
                org_cname: '',
                cat_cname: '',
                listData: [],
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            this.formData.role_id = this.$base.getRequest().role_id;
            this.formData.org_id = this.$base.getRequest().org_id;
            this.role_cname = this.$base.getRequest().role_cname;
            this.org_cname = this.$base.getRequest().org_cname;
            this.cat_cname = this.$base.getRequest().cat_cname;
            this.getInfo();
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            getInfo: function(){
                const {role_id, org_id} = {...this.formData};
                this.$base.showLoading();
                this.$request.sendPost("down-role-s2/before-set-func",{role_id, org_id},(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.listData = data.list;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            submit: function(url){
                this.formData.funcs = [];
                var check_data = this.$refs["tree"].getCheckedNodes();
                check_data.map(item => {
                    if(item.func_type && item.func_type == 'P'){
                        this.formData.funcs.push(item.func_id)
                    }
                });
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        this.$base.showLoading();
                        this.$request.sendPost(url,this.formData,(success,data,error)=>{
                            this.$base.hideLoading();
                            if(success){
                                this.$base.msgSuccess(error.errmsg);
                                this.relist = true;
                                this.$base.linkBack();
                            }
                            else{
                                this.$base.msgErr(error.errmsg);
                            }
                        });
                    } else {
                        this.$base.msgErr(this.$t('incomplete'));
                    }
                })
            },
            submitAll: function () {
                let content = this.$t('confirm_saverole');
                let title =  this.$t('tips');
                this.$base.confirm(title,content, () => {
                    this.submit('down-role-s2/set-func-all')
                },()=>{})
            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/org/downrole/downroles2_func.vue